import Skeleton from '@pelckmans/elementis/components/skeleton';
import { Cell } from '@pelckmans/elementis/components/table/cell';
import { useId } from 'react';

interface BaseProps {
  columns?: number;
  rows?: number;
  id?: string;
}

interface OptionalAriaLabelProps extends BaseProps {
  isLoading?: false;
  'aria-label'?: string;
}

interface LoadingProps extends BaseProps {
  isLoading: true;
  'aria-label': string;
}

export type SkeletonTableProps = OptionalAriaLabelProps | LoadingProps;

function TableSkeleton({ isLoading = false, columns = 5, rows = 8, 'aria-label': ariaLabel, id }: SkeletonTableProps) {
  const tableId = useId();
  return (
    <table className="table" aria-busy={isLoading} aria-label={ariaLabel} aria-describedby={id}>
      <tbody>
        {Object.keys(Array.from({ length: rows })).map(key => (
          <tr key={`row-${tableId}-${key}`}>
            {Object.keys(Array.from({ length: columns })).map(key => (
              <Cell key={`cell-${tableId}-${key}`}>
                <Skeleton className="skeleton" animate={isLoading} aria-label={undefined}>
                  <Skeleton.Bone height={20} />
                </Skeleton>
              </Cell>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default TableSkeleton;
